import React, { useState } from 'react';
import styled from 'styled-components';
import { registry } from '../../core/Registry.js';

const Wrapper = styled.div`
  width: ${props => props.width || '100%'};
  max-width: 600px;
  margin: ${props => props.align === 'center' ? '0 auto' : (props.align === 'right' ? '0 0 0 auto' : '0')};
  background: linear-gradient(135deg, var(--glass-1), rgba(6,182,212,0.05));
  border: 1px solid var(--glass-border);
  border-radius: 16px;
  padding: 30px;
  text-align: center;
  backdrop-filter: blur(10px);
  box-shadow: 0 10px 30px rgba(0,0,0,0.1);
`;

const Title = styled.h3`
  margin: 0 0 10px 0;
  color: var(--text-primary);
  font-size: 22px;
`;

const Subtitle = styled.p`
  margin: 0 0 25px 0;
  color: var(--text-muted);
  font-size: 14px;
`;

const InputGroup = styled.div`
  display: flex;
  background: var(--glass-2);
  border: 1px solid var(--glass-border);
  border-radius: 12px;
  padding: 5px;
  margin-bottom: 15px;

  @media(max-width: 500px) {
    flex-direction: column;
  }
`;

const PhonePrefix = styled.div`
  display: flex;
  align-items: center;
  padding: 0 15px;
  color: var(--text-secondary);
  font-weight: bold;
  border-right: 1px solid var(--glass-border);
  
  @media(max-width: 500px) {
    border-right: none;
    border-bottom: 1px solid var(--glass-border);
    padding: 10px 15px;
  }
`;

const Input = styled.input`
  flex: 1;
  background: transparent;
  border: none;
  padding: 12px 15px;
  color: #fff;
  font-size: 16px;
  outline: none;
  &::placeholder { color: var(--text-muted); }
`;

const Button = styled.button`
  background: linear-gradient(135deg, var(--accent), var(--accent-neon));
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 0 25px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.2s;

  &:hover { box-shadow: 0 4px 15px var(--accent-glow); }

  @media(max-width: 500px) {
    padding: 15px;
  }
`;

const ResultMock = styled.div`
  margin-top: 20px;
  background: rgba(16, 185, 129, 0.1);
  border: 1px solid rgba(16, 185, 129, 0.3);
  color: #10b981;
  padding: 15px;
  border-radius: 8px;
  font-weight: bold;
  display: none; /* Mock */
`;

const DslSpeedCheckWidget = ({ node }) => {
  return (
    <Wrapper align={node.style?.desktop?.align} width={node.style?.desktop?.width}>
      <Title>{node.content?.title || 'Internet Verfügbarkeit prüfen'}</Title>
      <Subtitle>{node.content?.subtitle || 'Prüfe jetzt, ob DSL, Kabel oder Glasfaser an deiner Adresse verfügbar ist.'}</Subtitle>
      <InputGroup>
        <PhonePrefix>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="16" style={{marginRight:8}}><path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"></path></svg>
        </PhonePrefix>
        <Input type="text" placeholder="PLZ, Ort, Straße, Hausnummer" />
        <Button className="tef-bubbles">Prüfen</Button>
      </InputGroup>
      <ResultMock>Glasfaser bis 1.000 MBit/s verfügbar!</ResultMock>
    </Wrapper>
  );
};

registry.register('dsl_speed_check', {
  label: 'Internet Check',
  icon: '🌐',
  category: 'tef_specific',
  defaultContent: {},
  defaultStyle: { desktop: { align: 'center', width: '100%' } },
  render: DslSpeedCheckWidget,
  inspectorControls: [
    { tab: 'content', groups: [{ title: 'Texte', fields: [{name:'content.title', label:'Titel', type:'text'}, {name:'content.subtitle', label:'Untertext', type:'textarea'}] }] },
    { tab: 'style', groups: [{ title: 'Layout', fields: [{name:'style.desktop.align', label:'Ausrichtung', type:'select', options:[{label:'Zentriert', value:'center'},{label:'Links', value:'flex-start'}]}] }] }
  ]
});
